import React from "react";
import { MdLocalShipping } from "react-icons/md";
import { CgRedo } from "react-icons/cg";

/**
 * SEO-Optimized Banner Bottom Section
 * Highlights key trade features, transport, and global market integration
 */
const BannerBottom = () => {
  return (
    <section
      className="w-full bg-white border-b border-gray-200 py-6 px-4"
      aria-label="Key Features of RK Global Trader"
    >
      <div className="max-w-container mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
        {/* Global Market Feature */}
        <div
          className="flex items-center gap-3 w-full md:w-72 shadow-sm hover:shadow-md duration-300 p-3 rounded-md"
          aria-label="Global Trade and Market Integration"
        >
          <span className="font-bold font-titleFont w-6 text-center">1.</span>
          <p className="text-gray-700 text-base font-medium">
            Connecting exporters to global markets seamlessly.
          </p>
        </div>

        {/* Reliable Shipping Feature */}
        <div
          className="flex items-center gap-3 w-full md:w-72 shadow-sm hover:shadow-md duration-300 p-3 rounded-md"
          aria-label="Reliable Shipping Services"
        >
          <span className="text-xl w-6 text-center text-primeColor">
            <MdLocalShipping />
          </span>
          <p className="text-gray-700 text-base font-medium">
            Trusted and timely international shipping solutions.
          </p>
        </div>

        {/* Economic Integration Feature */}
        <div
          className="flex items-center gap-3 w-full md:w-72 shadow-sm hover:shadow-md duration-300 p-3 rounded-md"
          aria-label="Global Economic Integration"
        >
          <span className="text-2xl w-6 text-center text-primeColor">
            <CgRedo />
          </span>
          <p className="text-gray-700 text-base font-medium">
            Supporting worldwide trade and integrating the global economy.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BannerBottom;
